import React from "react";
// import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
// import MicIcon from "@mui/icons-material/Mic";
import SendIcon from "@mui/icons-material/Send";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// import ThumbUpIcon from "@mui/icons-material/ThumbUp";
// import CommentIcon from "@mui/icons-material/Comment";
import Zoom from "react-medium-image-zoom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import AttachmentOutlinedIcon from "@mui/icons-material/AttachmentOutlined";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import CreateNewTicket from "./CreateNewTicket";
// End

import {
  makePostRequest,
  makeGetRequest,
  uploadFileRequest,
} from "../../../utils/utils";
import swal from "sweetalert";
import moment from "moment";
import avtarPic from "../../../assets/Images/avtarPic.png";
// End

import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import RefreshIcon from "@mui/icons-material/Refresh";
// import CallIcon from "@mui/icons-material/Call";
// import dayjs from "dayjs";
import EditIcon from "@mui/icons-material/Edit";
// import { EditNotificationsRounded } from "@mui/icons-material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import pdfImage from "../../../assets/Images/pdf.png";
import reecordNotFound from "../../../assets/Images/noData2.gif";
import Pagination from '@mui/material/Pagination';

function TechSupport() {
  // const navigate = useNavigate();

  const [age, setAge] = React.useState("Open Tickets");

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [userId, setUserId] = React.useState();
  const [Update, setUpdate] = React.useState(false);

  const [ticketList, setTicketList] = React.useState([]);
  const [ticketReplyList, setTicketReplyList] = React.useState([]);
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [activeIndex, setActiveIndex] = React.useState(null);
  const [ticketStatus, setTicketStatus] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [, setActiveIndexres] = React.useState(null);
  // add ticket
  const [ticketTitle, setTicketTitle] = useState("");
  const [description, setDescription] = useState("");
  const [attachment, setAttachment] = useState([]);
  const [, setMemberId] = useState();
  const [, setshowerr] = React.useState(false);
  // const [, setresidentlist] = React.useState([]);
  const [, setqres] = React.useState("");
  const [invoice_date] = React.useState(new Date());
  const [errmsg, seterrmsg] = React.useState(false);
  const [msgtitle, setmsgTittle] = useState("");
  // const [open2, setOpen2] = React.useState(false);
  const [iseditflag, setiseditflag] = React.useState(false);
  const [editTicketId, seteditTicketId] = React.useState();
  const [Upload, setUpload] = useState(false);
  const [txtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );
  const [excelImage] = React.useState(
    require("../../../assets/Images/exel.png")
  );
  const [wordImage] = React.useState(
    require("../../../assets/Images/doc.png")
  );

  const [q, setQ] = React.useState("");

  const [bindurls, setbindurls] = React.useState([]);
  const [sort, setSort] = React.useState("newtoold");

  //pagination
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage] = React.useState(3);
  const [totalItems, setTotalItems] = React.useState(0);

  const MAX_LENGTH = 100;

  const Validation_Schema = Yup.object().shape({
    ticketTitle: Yup.string()
      .trim("White spaces not allow")
      .strict(true)
      .required("Required")
      .matches(/^[a-zA-Z .'"]*$/, "Please enter valid ticket title"),
    description: Yup.string()
      .trim("White spaces not allow")
      .strict(true)
      .required("Required"),
    attachment: Yup.string(),
    // memberId: Yup.number(),
  });

  if (editTicketId > 0) {
    var formikInitials = {
      ticketTitle: ticketTitle,
      description: description,
    };
  } else {
     formikInitials = {
      ticketTitle: "",
      description: "",
      // attachment: [],
      // memberId: "",
    };
  }


  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = (status) => {
    setAnchorEl(null);
    setTicketStatus(status);
    // getAllTickets();
  };
  // End
  const handleFilter = (e) => {
    // setAnchorEl(null);
    if (e.currentTarget.dataset.myValue !== undefined) {
      setSort(e.currentTarget);
    }
    setAnchorEl(null);
  };
  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const handleClickOpen = (scrollType) => () => {
    // residentlisting();
    setOpen(true);
    setScroll(scrollType);
    setTicketTitle("");
    setDescription("");
    setMemberId();
    setAttachment([]);
    setActiveIndexres(null);
  };

  const handleClose = () => {
    setqres("");
    setOpen(false);
    setiseditflag(false);
    setTicketTitle("");
    setDescription("");
    setMemberId();
    setAttachment([]);
    setActiveIndexres(null);
    // seteditTicketId()
  };

  async function getAllTickets() {
    setShowLoader(true);
    setTicketList([]);
    let inputData = {
      searchString: q,
      status: ticketStatus,
      sort: sort,
      pageNo: currentPage,
      count: itemsPerPage,
    };
    await makePostRequest("techsupport/ticketListing", inputData)
      .then((response) => {
        if (response.data.status === "1") {
          const data = response.data.data.data;
          if (data.length > 0) {
    
            setTicketList(data);
            detailTicket(response.data.data.data[0]);
            setTotalItems(response.data.data.total_records);
            setShowLoader(false);
         
          } else {
            setShowLoader(false);
            setTicketList([]);
          }
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  const detailTicket = async (ticketObj) => {
    seterrmsg(false);
    // setCommentsList([]);
    // setSubCommentsList([]);
    setTicketReplyList([]);
    setSelectedItem(ticketObj);
    setActiveIndex(ticketObj.tech_support_id);
    localStorage.setItem("selecetdtechTicketObj", JSON.stringify(ticketObj));
    getAllTicketReply(ticketObj.tech_support_id);
  };

  async function getAllTicketReply(ticketId) {
    setShowLoader(true);
    await makeGetRequest("techsupport/getallticketreply/" + ticketId)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data;
          if (data[0].json_agg) {
            setShowLoader(false);
            setTicketReplyList(data[0].json_agg);
            setUpdate(!Update);
          } else {
            setShowLoader(false);
            setTicketReplyList([]);
          }
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handleInputChange = (e) => {
    const inputValue = e.target.value.slice(0, 255);
    if (inputValue.trim() === "") {
      seterrmsg(true);
    } else if (inputValue.trim() !== inputValue) {
      seterrmsg(true);
    } else {
      seterrmsg(false);
    }
    setmsgTittle(inputValue);
    // seterrmsg(false);
  };
  async function addReply(ticketId) {
    // e.preventDefault();

    // let reply = document.getElementById("mainReply").value;

    if (msgtitle) {
      seterrmsg(false);
      var inputdata = "";

      inputdata = {
        tech_support_id: ticketId,
        reply_title: msgtitle,
        member_id: localStorage.getItem("userId"),
      };
      setShowLoader(true);
      await makePostRequest("techsupport/addTicketreply", inputdata)
        .then((response) => {
          if (response.status === 201) {
            setmsgTittle("");
            // document.getElementById("mainReply").value = "";
            getAllTicketReply(ticketId);
            // setUpdate(!Update);
            setShowLoader(false);
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      seterrmsg(true);
      // swal("Empty Reply!", "Unable to send empty reply", "warning");
    }
  }

  async function handleTicketStatus(tid, status) {
    let textvar;
    let text;
    if (status) {
      textvar = "close";
      text = `Do you really want to ${textvar} this ticket? This process can not be undone.`;
    } else {
      textvar = "re-open";
      text = `Do you really want to ${textvar} this ticket?`;
    }

    // if (ticketObj.is_resolve==true) {
    //   setTicketStatus(false);

    // } else {
    //   setTicketStatus(true);
    // }
    // e.preventDefault();

    const willDelete = await swal({
      title: "Are you sure?",
      text: `${text}`,
      // text: `Do you really want to ${textvar} this ticket? This process can not be undone.`,
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, I am sure!"],
    });
    if (willDelete) {
      let inputdata = {
        tech_support_id: tid,
        is_resolve: status,
        updated_at: invoice_date,
      };
      await makePostRequest("techsupport/updateTicket", inputdata)
        .then((response) => {
          if (response.data.status === "1") {
            // window.location.reload();
            getAllTickets();
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    }
  }

  // add ticket

  async function addTicket() {
    // e.preventDefault();
    
      setshowerr(false);
      setShowLoader(true);
      var inputdata = "";

      inputdata = {
        ticket_title: ticketTitle,
        description: description,
        fileuploaded: attachment,
        // ticket_visible_flag: radiovalue,
        sender_id: localStorage.getItem('userId'),
        // member_id: membersIds,
        is_new: true,
        society_id: localStorage.getItem('socityid')
      };

      await makePostRequest("techsupport/createTechTicket", inputdata)
        .then((response) => {
          if (response.data.status === "1") {
            swal("Success", "Ticket created successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            setOpen(false);
            setTicketTitle("");
            setDescription("");
            setMemberId();
            setAttachment([]);
            setActiveIndexres(null);
            // window.location.reload();
            setShowLoader(false)
            getAllTickets()

          }
        })
        .catch((err) => {
          setShowLoader(false)
          swal("There was an error!", "more error details", "warning");
        });
    
  }

  // add ticket member list
  // async function residentlisting() {
  //   setShowLoader(true);
  //   let bodyFormData = {
  //     searchq: qres,
  //     pageNo: "",
  //     count: "",
  //     // isTenent: false,
  //   };
  //   setShowLoader(true);
  //   await makePostRequest("resident/residentandtenentlisting", bodyFormData)
  //     .then((response) => {
  //       if (response.status === 201) {
  //         console.log("resi li", response.data.data.rows);
  //         const data = response.data.data.rows;
  //         setresidentlist(data);
  //         setShowLoader(false);
  //       } else {
  //         setShowLoader(false);
  //         swal("There was an error!", response.message, "warning");
  //       }
  //     })
  //     .catch((err) => {
  //       setShowLoader(false);
  //       swal("There was an error!", "more error details", "warning");
  //     });
  // }

  // async function selectedResident(residentObj) {
  //   setshowerr(false);
  //   setActiveIndexres(residentObj.resident_id);
  //   setMemberId(residentObj.resident_id);
  // }

  const [docErrorMsg, setDocErrorMsg] = React.useState("");
  async function uploadfile(e) {
    setDocErrorMsg("");
    const file = e.target.files[0];
    console.log(e.target.files[0]);
    if (await validateImageOrFile(file)) {
      setShowLoader(true);
      var profilePicUrl = await addattachment(file);
      attachment.push(profilePicUrl);
      setAttachment(attachment);
      setShowLoader(false);
    } else {
      setShowLoader(false);
      setDocErrorMsg("Invalid file format");
    }
  }

  async function validateImageOrFile(fileData) {
    if (
      fileData.name.match(
        /.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF|docx|DOCX|doc|DOC|pdf|PDF|xls|XLS|txt|TXT|xlsx|XLSX)$/i
      )
    )
      return true;
    else return false;
  }

  async function addattachment(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    let fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
        // let filename = response.data.imagepath[0].originalname;
        // setFilename(filename);
        console.log(fileUrl);
      }
    );
    return fileUrl;
  }

  async function deleteDocument(index) {
    attachment.splice(index, 1); // 2nd parameter means remove one item only
    setAttachment(attachment);
    console.log("fil", Upload);
    setUpload(!Upload);
  }

  const handleEditTicket = (scrollType, optn) => () => {
    console.log(optn.fileuploaded);
    // localStorage.setItem("isEditTicket", true);
    // localStorage.setItem("editTicketId", tId);
    setiseditflag(true);
    seteditTicketId(optn.tech_support_id);
    setTicketTitle(optn.ticket_title);
    setDescription(optn.description);
    setAttachment(optn.fileuploaded);
    setOpen(true);
    setScroll(scrollType);
  };

  async function editTicket() {
    // e.preventDefault();

    var inputdata = "";

    inputdata = {
      tech_support_id: editTicketId,
      ticket_title: ticketTitle,
      description: description,
      fileuploaded: attachment,
      updated_at: invoice_date,
    };

    await makePostRequest("techsupport/updateTicket", inputdata)
      .then((response) => {
        if (response.data.status === "1") {
          swal("Success", "Ticket updated successfully", "success", {
            timer: 1000,
            buttons: false,
          });
          setOpen(false);
          setiseditflag(false);
          getAllTickets()
          // window.location.reload();
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  let clkindex = null;
  const urls = [];
  const viewDocs = (nId, index, fileuploaded) => {
    setbindurls([]);
    urls.length = 0;
    bindurls.length = 0;
    const btn = document.getElementById("noticeSlideID" + index);
    if (btn) {
      if (clkindex !== null) {
        const prevDivindex = document.getElementById(
          "noticeSlideID" + clkindex
        );
        if (prevDivindex) {
          prevDivindex.classList.remove("filesDiv");
        }
      }
      btn.classList.toggle("filesDiv");
      clkindex = index;
    }

    fileuploaded.forEach((item) => {
      try {
        console.log(typeof item);
        const parsedItem = JSON.parse(item);

        if (parsedItem && parsedItem.path) {
          urls.push(parsedItem.path);
        } else {
          urls.push(item);
        }
      } catch (error) {
        urls.push(item);
        console.error("Error:", error);
      }
    });
    setbindurls(urls);
  };

  // const descriptionElementRef = React.useRef(null);
  
  React.useEffect(() => {
     if (Upload) {
      setUpload(false);
    } 
    // else if (localStorage.getItem("userType") === 'SuperAdmin') {
    //   setUserId(localStorage.getItem("userId"));
    //   getAllTickets();
    // }
    else {
      setUserId(localStorage.getItem("userId"));
      getAllTickets();
      // residentlisting();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, ticketStatus, Upload, sort, currentPage]);
  // End

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);

  const chatExpandClick = () => {
    var element = document.getElementById("chatExpandId");
    element.classList.toggle("chatExpandedClassTicket");
  };

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
           
            <h1 className="panelHeading">
              Tech Support Tickets
            </h1>
            {(localStorage.getItem("userType")==="SocietyAdmin" || localStorage.getItem("userType") === "Admin Owner") &&
            <Button
              className="contentTopLefBt addCommiteeBt"
              onClick={handleClickOpen("body")}
            >
              Create New Ticket
            </Button>
}
          </Grid>
          <Grid item xs={12} md={12}>
            <div
              className="noticePageMain discutionForumMain ticketsMain"
              id="chatExpandId"
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  {!ticketStatus ? (
                    <h1 className="panelHeading panelSubHeadingSt">
                      Open Tickets
                    </h1>
                  ) : (
                    <h1 className="panelHeading panelSubHeadingSt">
                      Closed Tickets
                    </h1>
                  )}
                </Grid>
                <Grid item xs={12} md={12}>
                  <div>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <div className="visitorSearchDiv ticketSearchOnly">
                          <SearchIcon className="visitorSearchIco" />
                          <input
                            type="text"
                            placeholder="Search by ticket title or description or ticket no. or users"
                            onChange={(e) => setQ(e.target.value)}
                          />
                          {/* <MicIcon className="visitorMicIco" /> */}
                          <SortIcon
                            className="visitorFilterIco tickeetShortIco"
                            aria-controls={openMenu ? "basic-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={openMenu ? "true" : undefined}
                            onClick={handleClick}
                          />
                        </div>

                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={openMenu}
                          onClose={handleFilter}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          <MenuItem
                            onClick={handleFilter}
                            data-my-value={"newtoold"}
                          >
                            Newest to Oldest
                          </MenuItem>
                          <MenuItem
                            onClick={handleFilter}
                            data-my-value={"oldtonew"}
                          >
                            Oldest to Newest
                          </MenuItem>
                        </Menu>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                          <InputLabel
                            className="ticketLab"
                            id="demo-simple-select-label"
                          >
                            Tickets Type
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={age}
                            // label="Age"
                            onChange={handleChange}
                            className="ticketDrop"
                          // defaultValue="Open Tickets"
                          >
                            <MenuItem
                              value={"Open Tickets"}
                              onClick={() => handleCloseMenu(false)}
                            >
                              Open Tickets
                            </MenuItem>
                            <MenuItem
                              value={"Close Tickets"}
                              onClick={() => handleCloseMenu(true)}
                            >
                              Closed Tickets
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>

                
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className="visitorListNewInner">
                    <div className="noticeTabMain tickOut">
                      <div className="noticeTbContDiv">
                        {ticketList.length > 0 ? (
                          <>
                            {ticketList.map((option, index) => (
                              <div
                                key={option.tech_support_id}
                                className={
                                  option.tech_support_id === activeIndex
                                    ? "parkSocityInner activeNotice"
                                    : "parkSocityInner"
                                }
                                onClick={() => detailTicket(option)}
                                selectedItem={selectedItem}
                              >
                                <div className="parkSocityTop closeChatSelectIcoOut">
                                  <span
                                    className="ticketEditIco"
                                    onClick={handleEditTicket("body", option)}
                                  >
                                    <EditIcon className="" />
                                  </span>
                                  <div className="parkSocityTopPro">
                                    {option.profile ? (
                                      <Zoom>
                                        <img src={option.profile} alt="altimg" />
                                      </Zoom>
                                    ) : (
                                      <img alt="Remy Sharp" src={avtarPic} />
                                    )}
                                  </div>
                                  <div className="parkSoHeadingMain">
                                    <h4>
                                      {option.fname} {option.lname}
                                    </h4>
                                    <span>
                                      {moment(option.created_at).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </span>
                                  </div>
                                  <div className="parkWi">
                                    <b>{option.contact_no}</b>{" "}
                                    <span>
                                      {moment(option.created_at).format(
                                        "h:mm:ss a"
                                      )}
                                    </span>
                                  </div>
                                  {/* <CloseIcon
                                className="closeChatSelectIco"
                                onClick={() => handleTicketStatus(option)}
                              /> */}
                                </div>
                                <div className="ticketBottOut">
                                  <div className="ticketLeft">
                                    <p className="pstHead TicNo">
                                      Ticket No. {"T" + option.tech_support_id}
                                    </p>

                                    <p className="pstHead">
                                      {option.ticket_title}
                                    </p>
                                    <p className="parContTx">
                                      {option.description.length >
                                        MAX_LENGTH ? (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              option.description.substring(
                                                0,
                                                MAX_LENGTH
                                              ) + "...",
                                          }}
                                        ></div>
                                      ) : (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: option.description,
                                          }}
                                        ></div>
                                      )}
                                    </p>
                                  </div>
                                  <div className="ticketRight">
                                    {option.is_resolve ? (
                                      <Button
                                        className="ticketActions openticketSt"
                                        onClick={() =>
                                          handleTicketStatus(
                                            option.tech_support_id,
                                            false
                                          )
                                        }
                                      >
                                        <RefreshIcon />
                                        Reopen
                                      </Button>
                                    ) : (
                                      <Button
                                        className="ticketActions closeticketSt"
                                        onClick={() =>
                                          handleTicketStatus(
                                            option.tech_support_id,
                                            true
                                          )
                                        }
                                      >
                                        <CloseIcon />
                                        Close
                                      </Button>
                                    )}
                                  </div>
                                </div>
                                <div className="boxActions">
                                  {option?.fileuploaded?.length > 0 && (
                                    <span
                                      onClick={() =>
                                        viewDocs(
                                          option.tech_support_id,
                                          index,
                                          option.fileuploaded
                                        )
                                      }
                                      className="downoadYourFile"
                                    >
                                      <FileDownloadIcon className="" />
                                      <em>Show Documents To Download </em>
                                    </span>
                                  )}
                                </div>
                                <div
                                  className="expandfilesDiv"
                                  id={"noticeSlideID" + index}
                                >
                                  <div className="doqumentDiv1">
                                    {option?.fileuploaded?.length > 0 && (
                                      <>
                                        {bindurls.map((opt, index) => (
                                          <div
                                            id="documentDiv"
                                            className="doqumentDiv1"
                                          >
                                            <a href={opt} target="_blank" rel="noreferrer">
                                              <div className="doquView">
                                                {opt.split(".").pop() ===
                                                  "txt" ? (
                                                  <img src={txtImage} alt="altimg"/>
                                                ) : opt.split(".").pop() ===
                                                  "pdf" ? (
                                                  <img src={pdfImage} alt="altimg"/>
                                                ) : opt.split(".").pop() ===
                                                  "docx" ||
                                                  opt.split(".").pop() ===
                                                  "doc" ? (
                                                  <img src={wordImage} alt="altimg"/>
                                                ) : opt.split(".").pop() ===
                                                  "xls" ||
                                                  opt.split(".").pop() ===
                                                  "xlsx" ? (
                                                  <img src={excelImage} alt="altimg"/>
                                                ) : (
                                                  <img src={opt} alt="altimg"/>
                                                )}
                                              </div>
                                            </a>
                                          </div>
                                        ))}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        ) : (
                          // <div className="noTickTx">
                          //   No Tickets Available....
                          // </div>
                          <div className="recordNotFound reduceSize">
                            <img src={reecordNotFound} alt="altimg"/>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Grid>

                {/* <Grid item xs={12} md={12}>
                  <div className="noTickTx">No Tickets Available....</div>
                </Grid> */}

                {ticketList.length > 0 && (
                  <Grid item xs={12} md={6}>
                    <div className="forChatExpandMain">
                      <div className="noticeRightCont discutiomRightMain chatCloseHoverSt reduceTopSpace">
                        <div className="parkSocityInner">
                          <Tooltip title="Full View" placement="top" arrow>
                            <FullscreenIcon
                              className="chatExpand fullView"
                              onClick={chatExpandClick}
                            />
                          </Tooltip>
                          <Tooltip title="Small View" placement="top" arrow>
                            <FullscreenExitIcon
                              className="chatExpand shortView"
                              onClick={chatExpandClick}
                            />
                          </Tooltip>
                          <div className="parkSocityTop parkSocityTopForChat">
                            <div className="parkSocityTopPro">
                              {selectedItem.profile ? (
                                <Zoom>
                                  <img src={selectedItem.profile} alt="altimg"/>
                                </Zoom>
                              ) : (
                                <img alt="Remy Sharp" src={avtarPic} />
                              )}
                            </div>
                            <div className="ticketRightHeadMain">
                              <h4>
                                {selectedItem.fname} {selectedItem.lname}
                              </h4>
                              <span>
                                {moment(selectedItem.created_at).format(
                                  "DD/MM/YYYY"
                                )}
                              </span>
                            </div>
                            <div className="parkWi">
                              <b>{selectedItem.contact_no}</b>{" "}
                              <span>
                                {moment(selectedItem.created_at).format(
                                  "h:mm:ss a"
                                )}
                              </span>
                            </div>
                            {/* <CloseIcon className="closeChatIco" /> */}
                          </div>
                          <div className="pstHead TicNo">
                            Ticket No. {"T" + selectedItem.tech_support_id}
                          </div>
                          <p className="parContTx">
                            {" "}
                            {selectedItem.ticket_title}
                          </p>
                          <p className="discutionSmallContTx">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: selectedItem.description,
                              }}
                            ></div>
                          </p>
                        </div>
                      </div>
                      <div className="disctionBottomContMain">
                      {(localStorage.getItem("userType")==="SocietyAdmin") &&
                        <div className="disctionComntScrol ticketChatMain">
                          {ticketReplyList.map((key, index) => (
                            <>
                              {key.member_id !== userId ? (
                                <div className="ticketChatLeft">
                                  <div className="parkSocityInner parkSocityInnerTicket">
                                    <div className="parkSocityTop">
                                      <div className="parkSocityTopPro">
                                        {key.profile ? (
                                          <Zoom>
                                            <img src={key.profile} alt="altimg"/>
                                          </Zoom>
                                        ) : (
                                          <img
                                            alt="Remy Sharp"
                                            src={avtarPic}
                                          />
                                        )}
                                      </div>
                                      <h4>
                                        {" "}
                                        {/* {key.fname} {key.lname} */}
                                        {"Admin"}
                                      </h4>
                                    </div>
                                    <p className="parContTx">
                                      {key.reply_title}
                                    </p>
                                    <p className="parContTx parContTxDate">
                                      {moment(key.created_at).format(
                                        "DD/MM/YYYY h:mm:ss a"
                                      )}
                                    </p>
                                  </div>
                                </div>
                              ) : (
                                <div className="ticketChatRight">
                                  <div className="parkSocityInner parkSocityInnerTicket">
                                    <div className="parkSocityTop">
                                      <div className="parkSocityTopPro">
                                        {key.profile ? (
                                          <Zoom>
                                            <img src={key.profile} alt="altimg"/>
                                          </Zoom>
                                        ) : (
                                          <img
                                            alt="Remy Sharp"
                                            src={avtarPic}
                                          />
                                        )}
                                      </div>
                                      <h4>
                                        {" "}
                                        {key.fname} {key.lname}
                                      </h4>
                                    </div>
                                    <div className="titlNDate">
                                      <p className="parContTx">
                                        {key.reply_title}
                                      </p>
                                      <p className="parContTx parContTxDate">
                                        {moment(key.created_at).format(
                                          "DD/MM/YYYY h:mm:ss a"
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ))}
                        </div>
}
{(localStorage.getItem("userType")==="SuperAdmin") &&
                        <div className="disctionComntScrol ticketChatMain">
                          {ticketReplyList.map((key, index) => (
                            <>
                              {key.member_id !== userId ? (
                                <div className="ticketChatLeft">
                                  <div className="parkSocityInner parkSocityInnerTicket">
                                    <div className="parkSocityTop">
                                      <div className="parkSocityTopPro">
                                        {key.profile ? (
                                          <Zoom>
                                            <img src={key.profile} alt="altimg"/>
                                          </Zoom>
                                        ) : (
                                          <img
                                            alt="Remy Sharp"
                                            src={avtarPic}
                                          />
                                        )}
                                      </div>
                                      <h4>
                                        {" "}
                                        {key.fname} {key.lname}
                                        {/* {"Admin"} */}
                                        
                                      </h4>
                                    </div>
                                    <p className="parContTx">
                                      {key.reply_title}
                                    </p>
                                    <p className="parContTx parContTxDate">
                                      {moment(key.created_at).format(
                                        "DD/MM/YYYY h:mm:ss a"
                                      )}
                                    </p>
                                  </div>
                                </div>
                              ) : (
                                <div className="ticketChatRight">
                                  <div className="parkSocityInner parkSocityInnerTicket">
                                    <div className="parkSocityTop">
                                      <div className="parkSocityTopPro">
                                        {key.profile ? (
                                          <Zoom>
                                            <img src={key.profile} alt="altimg"/>
                                          </Zoom>
                                        ) : (
                                          <img
                                            alt="Remy Sharp"
                                            src={avtarPic}
                                          />
                                        )}
                                      </div>
                                      <h4>
                                        {" "}
                                        {/* {key.fname} {key.lname} */}
                                        {"Admin"}
                                      </h4>
                                    </div>
                                    <div className="titlNDate">
                                      <p className="parContTx">
                                        {key.reply_title}
                                      </p>
                                      <p className="parContTx parContTxDate">
                                        {moment(key.created_at).format(
                                          "DD/MM/YYYY h:mm:ss a"
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ))}
                        </div>
}
                        {!ticketStatus && (
                          <div className="typeComentOut">
                            <div className="typeComentOutIco">
                              <SendIcon
                                onClick={() => addReply(selectedItem.tech_support_id)}
                              />
                              <textarea
                                className="textAriaChat"
                                value={msgtitle}
                                onChange={handleInputChange}
                                type="text"
                                id="mainReply"
                                placeholder={`Send a message to ${selectedItem.fname + " " + selectedItem.lname
                                  }...`}
                              />
                            </div>
                            {errmsg ? (
                              <div
                                style={{ color: "red" }}
                                className="errorField"
                              >
                                {"Required and white spaces not allow"}
                              </div>
                            ) : null}
                          </div>
                        )}
                      </div>
                    </div>
                  </Grid>
                )}
                {/* :<></>} */}
              </Grid>
            </div>
          </Grid>
          <Grid container spacing={3} >
            <Grid item xs={12} md={12} >
              <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                variant="outlined"
                shape="rounded" />
            </Grid>
          </Grid>
        </Grid>
      </div>

      {/* Create New Ticket */}
      <div className="modalMain">
        {iseditflag ? (
          <Dialog
            open={open}
            // onClose={handleClose}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            onClose={(event, reason) => {
              if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                setOpen(false);
                setiseditflag(false);
              }
            }}
          >
            <DialogTitle id="scroll-dialog-title" className="modalHeading">
              <span>Edit Ticket</span>
              <CloseIcon className="modalCloseBt" onClick={handleClose} />
            </DialogTitle>
            <DialogContent dividers={scroll === "paper"}>
              <div className="modalInnerCont">
                {/* <CreateNewTicket /> */}

                <div id="successfullAdd">
                  <Formik
                    enableReinitialize
                    initialValues={formikInitials}
                    validationSchema={Validation_Schema}
                    onSubmit={editTicket}
                  >
                    {({
                      values,
                      handleChange,
                      errors,
                      setFieldTouched,
                      touched,
                      isValid,
                      handleSubmit,
                    }) => (
                      <Form>
                        <Grid container spacing={3} className="addCommitee1">
                          <Grid item xs={12} md={12}>
                            <label className="tabsLabel">
                              Title Of Message
                            </label>
                            <input
                              maxLength={255}
                              className="inputSt"
                              placeholder="Title Of Message"
                              value={ticketTitle}
                              onChange={handleChange("ticketTitle")}
                              onBlur={() => setFieldTouched("ticketTitle")}
                              onChangeCapture={(e) =>
                                setTicketTitle(e.target.value)
                              }
                            />
                            {errors.ticketTitle && touched.ticketTitle ? (
                              <div
                                style={{ color: "red" }}
                                className="errorField"
                              >
                                {errors.ticketTitle}
                              </div>
                            ) : null}
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <label className="tabsLabel">
                              Enter Message Here
                            </label>
                            <textarea
                              className="textAriaSt textAriaStColor"
                              placeholder="Enter Message Here"
                              value={description}
                              onChange={handleChange("description")}
                              onBlur={() => setFieldTouched("description")}
                              onChangeCapture={(e) =>
                                setDescription(e.target.value)
                              }
                            ></textarea>
                            {errors.description && touched.description ? (
                              <div
                                style={{ color: "red" }}
                                className="errorField"
                              >
                                {errors.description}
                              </div>
                            ) : null}
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <div className="atchmentMain">
                              <div className="atchMain">
                                <AttachmentOutlinedIcon />
                                <input
                                  type="file"
                                  id="attachmentid"
                                  value={values.attachment}
                                  onChange={(event) => uploadfile(event)}
                                />
                                <span>Add Attachment</span>
                                <span className="formatNot">
                                  Note: format allowed for document- (pdf,image,docs,xls,text)
                                </span>
                              </div>
                            </div>
                            {/* {propertyImage} */}
                            <div className="fileName">
                              {attachment.length > 0 ? (
                                <>
                                  {attachment.map((option, index) => (
                                    <span className="uploaderFileOut">
                                      {option
                                        .split("/")
                                        .pop()
                                        .replace("%20", " ")}
                                      <IconButton>
                                        <CloseIcon
                                          onClick={() => deleteDocument(index)}
                                        />
                                      </IconButton>
                                    </span>
                                  ))}
                                </>
                              ) : (
                                <span>No File Uploaded</span>
                              )}
                            </div>
                            {docErrorMsg ? (
                              <div className="errorField errorFieldFForLogin forInvalidFile">
                                {docErrorMsg}
                              </div>
                            ) : (
                              <></>
                            )}
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <div className="modalMainBtMain">
                              <Button className="modalMainBt" type="submit">
                                Update
                              </Button>
                              {/* onClick={() => addTicket()} */}
                            </div>
                          </Grid>
                        </Grid>
                      </Form>
                    )}
                  </Formik>

                  <Grid container spacing={3} className="addCommitee2">
                    <Grid item xs={12} md={12}>
                      <div className="succesMain">
                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg"/>
                        <h4>Success !</h4>
                        <p>
                          Created New Ticket <br />
                          successfully in database
                        </p>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        ) : (
          <Dialog
            open={open}
            // onClose={handleClose}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            onClose={(event, reason) => {
              if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                setOpen(false);
                setiseditflag(false);
              }
            }}
          >
            <DialogTitle id="scroll-dialog-title" className="modalHeading">
              <span>Create New Ticket</span>
              <CloseIcon className="modalCloseBt" onClick={handleClose} />
            </DialogTitle>
            <DialogContent dividers={scroll === "paper"}>
              <div className="modalInnerCont">
                {/* <CreateNewTicket /> */}

                <div id="successfullAdd">
                  <Formik
                    enableReinitialize
                    initialValues={formikInitials}
                    validationSchema={Validation_Schema}
                    onSubmit={addTicket}
                  >
                    {({
                      values,
                      handleChange,
                      errors,
                      setFieldTouched,
                      touched,
                      isValid,
                      handleSubmit,
                    }) => (
                      <Form>
                        <Grid container spacing={3} className="addCommitee1">
                          
                          

                          <Grid item xs={12} md={12}>
                            <label className="tabsLabel">
                              Title Of Message
                            </label>
                            <input
                              maxLength={255}
                              className="inputSt"
                              placeholder="Title Of Message"
                              value={values.ticketTitle}
                              onChange={handleChange("ticketTitle")}
                              onBlur={() => setFieldTouched("ticketTitle")}
                              onChangeCapture={(e) =>
                                setTicketTitle(e.target.value)
                              }
                            />
                            {errors.ticketTitle && touched.ticketTitle ? (
                              <div
                                style={{ color: "red" }}
                                className="errorField"
                              >
                                {errors.ticketTitle}
                              </div>
                            ) : null}
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <label className="tabsLabel">
                              Enter Message Here
                            </label>
                            <textarea
                              className="textAriaSt textAriaStColor"
                              placeholder="Enter Message Here"
                              value={values.description}
                              onChange={handleChange("description")}
                              onBlur={() => setFieldTouched("description")}
                              onChangeCapture={(e) =>
                                setDescription(e.target.value)
                              }
                            ></textarea>
                            {errors.description && touched.description ? (
                              <div
                                style={{ color: "red" }}
                                className="errorField"
                              >
                                {errors.description}
                              </div>
                            ) : null}
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <div className="atchmentMain">
                              <div className="atchMain">
                                <AttachmentOutlinedIcon />
                                <input
                                  type="file"
                                  id="attachmentid"
                                  value={values.attachment}
                                  onChange={(event) => uploadfile(event)}
                                />
                                <span>Add Attachment</span>
                                <span className="formatNot">
                                  Note: format allowed for document- (pdf,image,docs,xls,text)
                                </span>
                              </div>
                            </div>
                            {/* {propertyImage} */}
                            <div className="fileName">
                              {attachment.length > 0 ? (
                                <>
                                  {attachment.map((option, index) => (
                                    <span className="uploaderFileOut">
                                      {option
                                        .split("/")
                                        .pop()
                                        .replace("%20", " ")}
                                      <IconButton>
                                        <CloseIcon
                                          onClick={() => deleteDocument(index)}
                                        />
                                      </IconButton>
                                    </span>
                                  ))}
                                </>
                              ) : (
                                <span>No File Uploaded</span>
                              )}
                            </div>
                            {docErrorMsg ? (
                              <div className="errorField errorFieldFForLogin forInvalidFile">
                                {docErrorMsg}
                              </div>
                            ) : (
                              <></>
                            )}
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <div className="modalMainBtMain">
                              <Button className="modalMainBt" type="submit">
                                Create
                              </Button>
                              {/* onClick={() => addTicket()} */}
                            </div>
                          </Grid>
                        </Grid>
                      </Form>
                    )}
                  </Formik>

                  <Grid container spacing={3} className="addCommitee2">
                    <Grid item xs={12} md={12}>
                      <div className="succesMain">
                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg"/>
                        <h4>Success !</h4>
                        <p>
                          Created New Ticket <br />
                          successfully in database
                        </p>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        )}
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default TechSupport;
